import React, { useEffect } from 'react';
import { Form, Input, DatePicker, Alert } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import CBModal from './CBModal';
import { partieGarantie } from '../services/partieGarantie';

const { TextArea } = Input;

/**
 * Modal de rejet de garantie (GARANTIE_DEMANDEE / GARANTIE_ATTENTE_CONFIRMATION → SANS_SUITE).
 * Le motif est obligatoire côté backend (RejetGarantieRequest.motif @NotBlank) :
 * on le rend obligatoire ici aussi pour éviter un aller-retour 400.
 *
 * Garantie non acquise → rejet : aucune pièce jointe. L'attestation de
 * non-garantie est un document généré en aval, pas un prérequis du rejet.
 */
export default function RejeterGarantieModal({ open, onClose, onConfirm, sinistre, loading }) {
  const { t } = useTranslation('commun');
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue({ dateReponse: dayjs() });
    }
  }, [open, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onConfirm({
      motif: values.motif,
      referenceGarantie: values.referenceGarantie || null,
      dateReponse: values.dateReponse ? values.dateReponse.format('YYYY-MM-DD') : null,
    });
  };

  return (
    <CBModal
      title={t('rejeterGarantieModal.titre')}
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={t('rejeterGarantieModal.titre')}
      cancelText={t('rejeterGarantieModal.annuler')}
      width={560}
      confirmLoading={loading}
      okButtonProps={{ danger: true }}
    >
      <Alert
        type="warning"
        showIcon
        message={t('rejeterGarantieModal.sinistre', { numero: sinistre?.numeroSinistreLocal || '' })}
        description={t('rejeterGarantieModal.refusRecu', { partie: `${partieGarantie(sinistre).de}${partieGarantie(sinistre).libelle ? ` ${partieGarantie(sinistre).libelle}` : ''}` })}
        style={{ marginBottom: 16 }}
      />

      <Form form={form} layout="vertical">
        <Form.Item
          name="motif"
          label={t('rejeterGarantieModal.motif')}
          rules={[{ required: true, message: t('rejeterGarantieModal.motifObligatoire') }]}
        >
          <TextArea rows={4} placeholder={t('rejeterGarantieModal.motifPlaceholder')} />
        </Form.Item>

        <Form.Item name="referenceGarantie" label={t('rejeterGarantieModal.reference')}>
          <Input placeholder={t('rejeterGarantieModal.referencePlaceholder')} />
        </Form.Item>

        <Form.Item name="dateReponse" label={t('rejeterGarantieModal.dateReponse', { partie: partieGarantie(sinistre).de })}>
          <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </CBModal>
  );
}
